<template>
  <div class="container">
    <h2 class="title">Articles</h2>
    <div class="articles-grid">
      <div class="article--item">
        <div class="article--item-box">
          <span class="article--title"
            ><h1>{{ article.title }}</h1>
          </span>
          <div class="share-article">
            <div class="sharethis-inline-share-buttons"></div>
          </div>
          <span class="article--autor"> {{ article.author }} </span>
          <span class="article--date">
            {{ article.date | date_articles }}
          </span>
          <p class="article--content" v-html="article.content"></p>
        </div>
        <div>
          <ith-article-comments />
        </div>
      </div>
      <div class="asside">
        <ith-table-o-t-t-platforms />
      </div>
      <div class=""></div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    params: {
      articleId: "",
    },
    article: {
      title: "",
      author: "",
      date: "",
      content: "",
      description: "",
      imageUrl: "",
    },
  }),
  // metaInfo: {
  //   title: "IMDB Recommended Movies and TV Shows - OTT Watchlist",
  //   meta: [
  //     {
  //       vmid: "description",
  //       name: "description",
  //       content: "",
  //     },
  //     {
  //       name: "keywords",
  //       content:
  //         "Watchlist news, IMDB recommended movies, tv show recommendations",
  //     },
  //   ],
  // },
  metaInfo() {
    return {
      // title: `OTT Watchlist - ${this.$route.params.slug}`,

      meta: [
        {
          vmid: "title",
          name: "title",
          content: `${this.article.title} - OTT Watchlist`,
        },
        {
          vmid: "description",
          name: "description",
          content: this.article.description.substr(0, 180),
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content: this.article.description.substr(0, 180),
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: `${this.article.title} - OTT Watchlist`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: `${this.article.imageUrl}`,
        },
      ],
    };
  },

  mounted() {
    let shareit = document.createElement("script");
    shareit.setAttribute(
      "src",
      "https://platform-api.sharethis.com/js/sharethis.js#property=5fbd983fc58f770012701424&product=sop"
    );
    shareit.setAttribute("async", true);
    document.head.appendChild(shareit);
    this.params.articleId = this.$route.params.id;
    this.$Parse.Cloud.run("getArticleDetail", this.params)
      .then((res) => {
        this.article = res;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.title {
  margin-left: 15px;
  font-size: 35px;
}
.articles-grid {
  display: grid;
  grid-template-columns: 70% 27%;
  column-gap: 3%;
}

.article--item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}
.article--item-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  padding-left: 20px;
  padding-right: 15px;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.article--title {
  padding-left: 20px;
  margin: 2% 0;
  font-weight: 600;
  color: #284367;
  font-size: 0.9em;
  line-height: 30px;
}
.article--title > h1 {
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.article--autor {
  padding-left: 20px;
  color: #283441;
  font-weight: 600;
  margin-top: 2%;
  color: #284367;
}
.article--date {
  padding-left: 20px;
  padding-bottom: 20px;
  font-size: 0.9em;
  color: #738092;
  border-bottom: 1px solid #939292;
}
.article--content {
  padding: 20px 20px 50px 20px;
  color: #738092;
  overflow: hidden;
}

.share-article {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1024px) and (max-width: 1264px) {
}
@media (min-width: 1020px) and (max-width: 1024px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .articles-grid {
    grid-template-columns: 95%;
    justify-content: center;
    row-gap: 50px;
  }
}

@media (max-width: 600px) {
  .articles-grid {
    grid-template-columns: 95%;
    justify-content: center;
    row-gap: 50px;
  }
}
</style>